// This file is auto-generated by scripts/generate-cms-overlay-catalog.ts.
import type { CmsOverlayClientRuntimeLoaderEntry } from '@/cms/components/overlays/runtime-registry-contract';

export const upgradeOverlayClientRuntimeEntries = [
  {
    type: 'upgrade-1',
    load: async () =>
      (await import('./upgrade-1.client-runtime')).upgradeOverlayClientRuntime,
  },
] satisfies CmsOverlayClientRuntimeLoaderEntry[];
